document.addEventListener("DOMContentLoaded", function () { // highlighting mega-menu li
    // Get the current path after the domain
    const currentPath = window.location.pathname;

    // Select all menu links
    const menuLinks = document.querySelectorAll(".mega-menu__nav a, navigation-drawer .panel__wrapper a");

    menuLinks.forEach(link => {
        // Check if the link href matches the current path
        if (link.getAttribute("href") === currentPath) {
            link.classList.add("menu-active"); // Add the active class to the link
            link.closest("li")?.classList.add("li-menu-active"); // Optionally add to <li>
        }
    });
});

document.querySelectorAll(".accordion-group .product-info__block-item details").forEach((el, index, allAccordions) => { // close accordions automatically when the clicked one is open
    el.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default summary toggle

        // Close all other accordions
        allAccordions.forEach((item) => {
            if (item !== this) {
                item.removeAttribute("open");
                item.setAttribute("aria-expanded", "false");
            }
        });

        // Open the clicked accordion
        this.setAttribute("open", "");
        this.setAttribute("aria-expanded", "true");

    });
});


$("document").ready(function(){
  // adjusting values from - and + icons of cart

  //console.log(window.location.pathname.indexOf('/cart/'));
  
  // inititate main quantity changer
  attachCartEvents();

  // attach event listner for the cart change
  document.addEventListener("cart:change", function(){
     
      //console.log('kevin');
      
      setTimeout(function(){
          attachCartEvents();
      }, 2000);
  }); 

  // update cart items
  function updateCartItem( variant_id, quantity, operation){
      
      //co
      var data = { updates: {} };
      var item_count;
      //var data = [{ quantity: quantity, id: variant_id }];
      data.updates[variant_id] = quantity;
      
      $(".loading_wait").show();
      $(".loading_overlay").show();

      jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function(result) { 
             
              $.when( 
                  jQuery.getJSON('/cart.js', function(cart) {
                      
                      item_count = cart.item_count;
                      let cartData = cart.items;
                      document.dispatchEvent(new CustomEvent('cart:build' ,{
                              bubbles: true
                          }
                      )); 
                      document.dispatchEvent(new CustomEvent('cart:refresh', {
                          bubbles: true,
                          detail: cartData
                      })); 
                  })
              ).then(function(){
                  
                  setTimeout(function(){
                      
                      // don't re-attach
                      if( window.location.pathname.indexOf('/cart/') == -1)
                          attachCartEvents();

                      $(".header__cart-count").find(".count-bubble").html(item_count);
                      $(".loading_wait").hide();
                      $(".loading_overlay").hide();
                      
                      // console.log('re-attached');
                  }, 2000);

              });
          }
      });
  }



  function justRefresh(){
      
    var data = { updates: {} };
    var item_count;
    
    $(".loading_wait").show();
    $(".loading_overlay").show();
  
    jQuery.ajax({
        type: 'GET',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(result) { 
           
            $.when( 
                jQuery.getJSON('/cart.js', function(cart) {
                    
                    item_count = cart.item_count;
                    let cartData = cart.items;
                    document.dispatchEvent(new CustomEvent('cart:build' ,{
                            bubbles: true
                        }
                    )); 
                    document.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true,
                        detail: cartData
                    })); 
                })
            ).then(function(){
                
                setTimeout(function(){
                    
                    // don't re-attach
                    if( window.location.pathname.indexOf('/cart/') == -1)
                        attachCartEvents();
  
                    $(".loading_wait").hide();
                    $(".loading_overlay").hide();
                    
                    // console.log('re-attached');
                }, 2000);
  
            });
  
            // console.log(result);
        }
    });
  }

  // main function for event attaching event listners
    function attachCartEvents(){
        $(".i_minus_cart").click(function(){
            //console.log("MINUS");
            
            var minus;
            
            let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');

            minus = parseInt( $inputBox.attr('value') ) - 1;
            
            $inputBox.attr('value', minus);
            
            //console.log($inputBox.attr('value'));
            //console.log(minus);
            //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', minus);
    
            var variant_id = $(this).parents('.line_changer').attr("line_var_id");
          
            updateCartItem(variant_id, minus, 'minus'); 
    
        });
        
        $(".i_plus_cart").click(function(){
            //console.log('PLUS')
            
            var plus, max, currrent_qty;
            let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');
            
            currrent_qty = parseInt( $inputBox.attr('value') );
            plus = currrent_qty + 1;
                
            $inputBox.attr('value', plus);

            //console.log(currrent_qty);
            //console.log(plus);
            //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', plus);

            var variant_id = $(this).parents('.line_changer').attr("line_var_id");
            updateCartItem(variant_id, plus, 'plus'); 
    
        });
      
        $("#nector-useyourcoins-container").click(function(){
            // justRefresh(); 
        });
      
    }
  
});

document.addEventListener("DOMContentLoaded", function () {
    function addCustomElement() {
        let hStack = document.querySelector(".h-stack.gap-2");

        if (!hStack) return;

        let parentFlexContainer = document.querySelector(".product-info .variant-picker__option-info");
        if (!parentFlexContainer) return;

        if (!document.querySelector(".new-element")) {
            let newElement = document.createElement("div");
            newElement.classList.add("new-element");
            newElement.style.display = "flex";
            newElement.style.alignItems = "center";
            newElement.style.gap = "8px";
            newElement.style.cursor = "pointer";

            let newText = document.createElement("span");
            newText.classList.add("new-text");
            newText.textContent = "Size Guide";
             if (window.matchMedia("(max-width: 700px)").matches) {
            newText.style.fontSize = "16px"; // Mobile font size
        } else {
            newText.style.fontSize = "20px"; // Desktop font size
        }
            newText.style.color = "#1C0802b3";

            let svgIcon = document.createElement("div");
            svgIcon.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="6" viewBox="0 0 21 6" fill="none">
                <g clip-path="url(#clip0_3495_3719)">
                  <mask id="mask0_3495_3719" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="6">
                    <path d="M0 0.5H21V5.49263H0V0.5Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_3495_3719)">
                    <path d="M0.0566406 0.806709V5.18339C0.0566406 5.20292 0.0589193 5.22223 0.0632234 5.24155C0.0675275 5.26063 0.0741103 5.27928 0.0824653 5.29726C0.0910735 5.31524 0.101454 5.33233 0.11386 5.34875C0.126266 5.36496 0.140191 5.37983 0.155888 5.39381C0.171839 5.40757 0.188802 5.41978 0.207284 5.43066C0.225767 5.44153 0.245515 5.45063 0.266023 5.45818C0.286531 5.46573 0.307798 5.47128 0.329572 5.47505C0.351346 5.47882 0.373372 5.48082 0.395653 5.48082H20.6257C20.648 5.48082 20.67 5.47882 20.6918 5.47505C20.7138 5.47128 20.7348 5.46573 20.7556 5.45818C20.7761 5.45063 20.7956 5.44153 20.8141 5.43066C20.8326 5.41978 20.8498 5.40757 20.8655 5.39381C20.8812 5.37983 20.8951 5.36496 20.9075 5.34875C20.9199 5.33233 20.9303 5.31524 20.9389 5.29726C20.9475 5.27928 20.9538 5.26063 20.9582 5.24155C20.9625 5.22223 20.9647 5.20292 20.9647 5.18339V0.806709C20.9647 0.787176 20.9625 0.767865 20.9582 0.748776C20.9538 0.729687 20.9475 0.711042 20.9389 0.693063C20.9303 0.674862 20.9199 0.657771 20.9075 0.641568C20.8951 0.625364 20.8812 0.610271 20.8655 0.596509C20.8498 0.582747 20.8326 0.570317 20.8141 0.559441C20.7956 0.548565 20.7761 0.539464 20.7556 0.531918C20.7348 0.524593 20.7138 0.518822 20.6918 0.515048C20.67 0.511275 20.648 0.509277 20.6257 0.509277H0.395653C0.373372 0.509277 0.351346 0.511275 0.329572 0.515048C0.307798 0.518822 0.286531 0.524593 0.266023 0.531918C0.245515 0.539464 0.225767 0.548565 0.207284 0.559441C0.188802 0.570317 0.171839 0.582747 0.155888 0.596509C0.140191 0.610271 0.126266 0.625364 0.11386 0.641568C0.101454 0.657771 0.0910735 0.674862 0.0824653 0.693063C0.0741103 0.711042 0.0675275 0.729687 0.0632234 0.748776C0.0589193 0.767865 0.0566406 0.787176 0.0566406 0.806709ZM0.734664 1.10414H20.287V4.88596H18.6091V2.99461C18.6091 2.97507 18.6068 2.95576 18.6025 2.93667C18.5982 2.91758 18.5919 2.89894 18.5833 2.88096C18.5749 2.86276 18.5643 2.84567 18.5519 2.82946C18.5398 2.81326 18.5256 2.79817 18.5099 2.78441C18.4942 2.77064 18.477 2.75821 18.4585 2.74734C18.44 2.73668 18.4205 2.72736 18.4 2.72004C18.3792 2.71249 18.3582 2.70694 18.3364 2.70295C18.3144 2.69917 18.2924 2.6974 18.2701 2.6974C18.2478 2.6974 18.2258 2.69917 18.204 2.70295C18.1823 2.70694 18.161 2.71249 18.1405 2.72004C18.12 2.72736 18.1005 2.73668 18.082 2.74734C18.0635 2.75821 18.0463 2.77064 18.0306 2.78441C18.0149 2.79817 18.0007 2.81326 17.9883 2.82946C17.9759 2.84567 17.9655 2.86276 17.9572 2.88096C17.9486 2.89894 17.9422 2.91758 17.9377 2.93667C17.9334 2.95576 17.9314 2.97507 17.9314 2.99461V4.88596H15.6368V2.99461C15.6368 2.97507 15.6345 2.95576 15.6302 2.93667C15.6259 2.91758 15.6195 2.89894 15.6109 2.88096C15.6023 2.86276 15.5919 2.84567 15.5795 2.82946C15.5671 2.81326 15.5532 2.79817 15.5375 2.78441C15.5218 2.77064 15.5046 2.75821 15.4861 2.74734C15.4676 2.73668 15.4481 2.72736 15.4274 2.72004C15.4069 2.71249 15.3859 2.70694 15.3638 2.70295C15.3421 2.69917 15.32 2.6974 15.2977 2.6974C15.2755 2.6974 15.2534 2.69917 15.2317 2.70295C15.2099 2.70694 15.1886 2.71249 15.1681 2.72004C15.1476 2.72736 15.1279 2.73668 15.1094 2.74734C15.0909 2.75821 15.0739 2.77064 15.0582 2.78441C15.0423 2.79817 15.0284 2.81326 15.016 2.82946C15.0035 2.84567 14.9932 2.86276 14.9846 2.88096C14.9762 2.89894 14.9696 2.91758 14.9653 2.93667C14.961 2.95576 14.9587 2.97507 14.9587 2.99461V4.88596H12.6644V2.99461C12.6644 2.97507 12.6621 2.95576 12.6578 2.93667C12.6535 2.91758 12.6469 2.89894 12.6386 2.88096C12.63 2.86276 12.6196 2.84567 12.6072 2.82946C12.5948 2.81326 12.5808 2.79817 12.5651 2.78441C12.5492 2.77064 12.5322 2.75821 12.5137 2.74734C12.4953 2.73668 12.4755 2.72736 12.455 2.72004C12.4345 2.71249 12.4132 2.70694 12.3915 2.70295C12.3697 2.69917 12.3477 2.6974 12.3254 2.6974C12.3031 2.6974 12.2811 2.69917 12.2593 2.70295C12.2375 2.70694 12.2163 2.71249 12.1957 2.72004C12.175 2.72736 12.1555 2.73668 12.137 2.74734C12.1185 2.75821 12.1013 2.77064 12.0856 2.78441C12.0699 2.79817 12.056 2.81326 12.0436 2.82946C12.0312 2.84567 12.0208 2.86276 12.0122 2.88096C12.0036 2.89894 11.9973 2.91758 11.9929 2.93667C11.9886 2.95576 11.9864 2.97507 11.9864 2.99461V4.88596H9.69202V2.99461C9.69202 2.97507 9.69 2.95576 9.68569 2.93667C9.68114 2.91758 9.67481 2.89894 9.6662 2.88096C9.65784 2.86276 9.64721 2.84567 9.63506 2.82946C9.62265 2.81326 9.60847 2.79817 9.59277 2.78441C9.57708 2.77064 9.55986 2.75821 9.54138 2.74734C9.5229 2.73668 9.5034 2.72736 9.48289 2.72004C9.46239 2.71249 9.44112 2.70694 9.41934 2.70295C9.39757 2.69917 9.37529 2.6974 9.35326 2.6974C9.33098 2.6974 9.30896 2.69917 9.28693 2.70295C9.26516 2.70694 9.24389 2.71249 9.22338 2.72004C9.20287 2.72736 9.18338 2.73668 9.1649 2.74734C9.14641 2.75821 9.1292 2.77064 9.1135 2.78441C9.0978 2.79817 9.08362 2.81326 9.07122 2.82946C9.05906 2.84567 9.04843 2.86276 9.04008 2.88096C9.03147 2.89894 9.02514 2.91758 9.02083 2.93667C9.01628 2.95576 9.01425 2.97507 9.01425 2.99461V4.88596H6.71991V2.99461C6.71991 2.97507 6.71763 2.95576 6.71333 2.93667C6.70902 2.91758 6.70269 2.89894 6.69408 2.88096C6.68547 2.86276 6.67509 2.84567 6.66269 2.82946C6.65028 2.81326 6.63636 2.79817 6.62066 2.78441C6.60496 2.77064 6.58775 2.75821 6.56926 2.74734C6.55078 2.73668 6.53129 2.72736 6.51078 2.72004C6.49002 2.71249 6.469 2.70694 6.44698 2.70295C6.4252 2.69917 6.40318 2.6974 6.3809 2.6974C6.35862 2.6974 6.33659 2.69917 6.31482 2.70295C6.29304 2.70694 6.27177 2.71249 6.25127 2.72004C6.23076 2.72736 6.21126 2.73668 6.19278 2.74734C6.17405 2.75821 6.15708 2.77064 6.14139 2.78441C6.12543 2.79817 6.11151 2.81326 6.0991 2.82946C6.0867 2.84567 6.07632 2.86276 6.06771 2.88096C6.05935 2.89894 6.05277 2.91758 6.04847 2.93667C6.04416 2.95576 6.04214 2.97507 6.04214 2.99461V4.88596H3.74729V2.99461C3.74729 2.97507 3.74501 2.95576 3.74071 2.93667C3.7364 2.91758 3.73007 2.89894 3.72146 2.88096C3.71285 2.86276 3.70247 2.84567 3.69007 2.82946C3.67766 2.81326 3.66374 2.79817 3.64804 2.78441C3.63234 2.77064 3.61513 2.75821 3.59664 2.74734C3.57816 2.73668 3.55867 2.72736 3.53791 2.72004C3.5174 2.71249 3.49613 2.70694 3.47436 2.70295C3.45258 2.69917 3.43056 2.6974 3.40828 2.6974C3.386 2.6974 3.36397 2.69917 3.3422 2.70295C3.32042 2.70694 3.29915 2.71249 3.27865 2.72004C3.25814 2.72736 3.23839 2.73668 3.21991 2.74734C3.20143 2.75821 3.18446 2.77064 3.16876 2.78441C3.15281 2.79817 3.13889 2.81326 3.12648 2.82946C3.11408 2.84567 3.1037 2.86276 3.09509 2.88096C3.08673 2.89894 3.08015 2.91758 3.07585 2.93667C3.07154 2.95576 3.06926 2.97507 3.06926 2.99461V4.88596H0.734664V1.10414Z" fill="#1C0802"/>
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_3495_3719">
                    <rect width="21" height="5" fill="white" transform="translate(0 0.5)"/>
                  </clipPath>
                </defs>
              </svg>`;

            newElement.appendChild(newText);
            newElement.appendChild(svgIcon);
            parentFlexContainer.appendChild(newElement);

            newElement.addEventListener("click", openPopup);
        }
    }
  // Listen for window resize to update font size dynamically
    window.addEventListener("resize", function () {
        let newText = document.querySelector(".new-text");
        if (newText) {
            if (window.matchMedia("(max-width: 700px)").matches) {
                newText.style.fontSize = "16px"; // Mobile font size
            } else {
                newText.style.fontSize = "20px"; // Desktop font size
            }
        }
    });
    function openPopup() {
        if (document.querySelector(".popup-container")) return;

        let popupContainer = document.createElement("div");
        popupContainer.classList.add("popup-container");
        popupContainer.style = `
            position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
            background: rgba(0, 0, 0, 0.6); display: flex;
            justify-content: center; align-items: center; z-index: 1000; padding: 20px;
        `;

        let popupContent = document.createElement("div");
        popupContent.style = `
            position: relative; padding: 30px; background: #fff; border-radius: 8px;
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2); text-align: center;
        `;

        let closeButton = document.createElement("span");
        closeButton.textContent = "×";
        closeButton.style = "position: absolute; top: 10px; right: 10px; cursor: pointer; font-size: 28px; font-weight: bold; color: #333;";
        closeButton.addEventListener("click", () => {
            popupContainer.remove();
            document.body.style.overflow = "auto";
        });

        let img = document.createElement("img");
        img.src = "https://cdn.shopify.com/s/files/1/0686/5207/3109/files/Size_Guide.png?v=1741087238";
        img.alt = "Size Guide";
        img.style = "width: 100%; max-width: 400px; border-radius: 8px;";

        popupContent.appendChild(closeButton);
        popupContent.appendChild(img);
        popupContainer.appendChild(popupContent);
        document.body.appendChild(popupContainer);

        popupContainer.addEventListener("click", (event) => {
            if (event.target === popupContainer) {
                popupContainer.remove();
                document.body.style.overflow = "auto";
            }
        });

        document.body.style.overflow = "hidden";
    }

    function ensureElementExists() {
        if (!document.querySelector(".new-element")) {
            addCustomElement();
        }
    }

    setInterval(ensureElementExists, 500);

    let targetNode = document.querySelector(".product-info .variant-picker__option-info");
    if (targetNode) {
        let observer = new MutationObserver(() => addCustomElement());
        observer.observe(targetNode, { childList: true, subtree: true });
    }

    addCustomElement();
});























